module.exports = __webpack_public_path__ + "static/media/net.3634546e.webp";